/**
 * Created by pc on 2018/12/29.
 */
import { post, get } from '@/agent/http'
import Page from '@/global/util/Page'
import { BASE_URL } from '@/global/util/constants'
import qs from 'qs'
const AGENT_FINANCE_DETAILS_TYPE_MENU = 'AGENT_FINANCE_DETAILS_TYPE_MENU' // 财务明细下拉菜单
const AGENT_FINANCE_DETAILS_TABLE_DATA = 'AGENT_FINANCE_DETAILS_TABLE_DATA' // 财务明细表格
const AGENT_FINANCE_ADVERTISER_MENU = 'AGENT_FINANCE_ADVERTISER_MENU' // 财务广告主下拉菜单
const AGENT_FINANCE_EDIT_TABLE = 'AGENT_FINANCE_EDIT_TABLE' // 财务编辑表格
const state = {
  financial: {
    finTypeMenu: [],
    curFinType: '',
    advertiserMenu: [],
    page: new Page(),
    detailsDown: '',
    editPage: new Page(),
    editDown: undefined
  }
}

const getters = {
  financial: state => state.financial
}

const actions = {
  getFinDetailsTypeMenu ({ commit, state }, { userType }) {
    post('/agency/finance/type', { user_type: userType }).then(res => {
      if (res.code === 1) {
        commit(AGENT_FINANCE_DETAILS_TYPE_MENU, res.data)
      }
    })
  },
  getAdvertiserMenu ({ commit, state }, { parentId }) {
    get('/agency/finance/list', { parent_id: parentId }).then(res => {
      if (res.code === 1) {
        commit(AGENT_FINANCE_ADVERTISER_MENU, res.data)
      }
    })
  },
  getFinDetailsTable (
    { commit, state },
    {
      pageSize = state.financial.page.pageSize,
      currentPage = state.financial.page.currentPage,
      userName,
      parentId,
      startTime,
      accountName,
      endTime,
      userId,
      userType,
      type
    } = {}
  ) {
    let params = {}
    params.page = currentPage
    params.page_size = pageSize
    params.start_time = startTime
    params.end_time = endTime
    params.type = type
    if (userType === '4') {
      params.p_id = parentId
    } else {
      params.user_id = userId
    }
    params.user_name = userName
    params.account_name = accountName
    params.user_type = userType
    state.financial.page.clearData()
    post('/agency/finance/detailed', params).then(res => {
      params.is_export = 1
      let downUrl = BASE_URL + '/agency/finance/detailed?' + qs.stringify(params)
      if (res.code === 1) {
        commit(AGENT_FINANCE_DETAILS_TABLE_DATA, { data: res.data, url: downUrl })
      }
    })
  },
  getEditFincialTable (
    { commit, state },
    {
      pageSize = state.financial.editPage.pageSize,
      currentPage = state.financial.editPage.currentPage,
      userId,
      accountName,
      parentId,
      userName
    }
  ) {
    let params = {}
    params.user_id = userId
    params.parent_id = parentId
    params.user_name = userName
    params.page = currentPage
    params.page_size = pageSize
    params.account_name = accountName
    get('/agency/finance/list', params).then(res => {
      params.is_export = 1
      let downUrl = BASE_URL + '/agency/finance/list?' + qs.stringify(params)
      if (res.code === 1) {
        commit(AGENT_FINANCE_EDIT_TABLE, { data: res.data, url: downUrl })
      }
    })
  }
}

const mutations = {
  [AGENT_FINANCE_DETAILS_TYPE_MENU] (state, data) {
    state.financial.finTypeMenu = data
    state.financial.curFinType = data.length ? data[0].value : ''
  },
  [AGENT_FINANCE_ADVERTISER_MENU] (state, data) {
    state.financial.advertiserMenu = data
  },
  [AGENT_FINANCE_DETAILS_TABLE_DATA] (state, data) {
    state.financial.page.setPageData(
      {
        header: data.data.header,
        data: data.data.data,
        total: data.data.count
      },
      false
    )
    state.financial.detailsDown = data.url
  },
  [AGENT_FINANCE_EDIT_TABLE] (state, data) {
    state.financial.editPage.setPageData(
      {
        header: data.data.header,
        data: data.data.data,
        total: data.data.total
      },
      false
    )
    state.financial.editDown = data.url
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
